import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-zoom-id-unavailable-dialog',
  templateUrl: './zoom-id-unavailable-dialog.component.html',
  styleUrls: ['./zoom-id-unavailable-dialog.component.css']
})
export class ZoomIdUnavailableDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ZoomIdUnavailableDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {
  }

  contactSupport(){
    window.open(this.data.supportLink, "_blank");
  }

}
